//TODO import cloud details from gatsby-config

export default {
	"name": "cloudinary",
	"config": {
		"cloud_name": "montessoribaby",
		"api_key": 128391412231336,
		"default_transformations": [
			[
				{
					"fetch_format": "auto",
					"quality": "auto"
				}
			]
		]
	}
};
